import { render, staticRenderFns } from "./DeliverableType.vue?vue&type=template&id=75ea9c7c&"
import script from "./DeliverableType.vue?vue&type=script&lang=js&"
export * from "./DeliverableType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ea9c7c')) {
      api.createRecord('75ea9c7c', component.options)
    } else {
      api.reload('75ea9c7c', component.options)
    }
    module.hot.accept("./DeliverableType.vue?vue&type=template&id=75ea9c7c&", function () {
      api.rerender('75ea9c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/DeliverableType.vue"
export default component.exports